<template>
  <div class="content">
    <div class="left">
      <div class="title">
        <div>
          <div style="font-size: 24px; margin-bottom: 20px">
            {{ info?.info?.title }}
          </div>
          <div class="detail">
            <span style="margin-right: 35px; font-size: 14px; color: #666666">
              <img
                src="@/assets/img/myAffairs/time.png"
                style="width: 14px; margin-right: 5px"
                alt=""
              />发布时间：{{ info?.info?.createTime }}</span
            >
          </div>
        </div>
        <!-- <div style="display: flex; margin-top: 20px">
          <div
            style="
              border-radius: 4px 4px 4px 4px;
              border: 1px solid #0fc26f;
              padding: 5px 10px;
              margin-right: 15px;
            "
          >
            <img
              src="@/assets/img/myAffairs/departLogo.png"
              style="width: 14px; margin-right: 5px"
              alt=""
            />关注部门
          </div>
          <div
            style="
              border-radius: 4px 4px 4px 4px;
              border: 1px solid #1da1f3;
              padding: 5px 10px;
            "
          >
            <img
              src="@/assets/img/myAffairs/noticeLogo.png"
              style="width: 14px; margin-right: 5px"
              alt=""
            />关注公告
          </div>
        </div> -->
      </div>
      <div
        style="font-size: 16px; color: #666666; margin-top: 20px"
        class="article-content"
        v-html="info?.info?.content"
      ></div>
      <div></div>
    </div>
    <!-- <div class="right">
      <div>
        <div
          style="
            font-weight: Regular;
            font-size: 16px;
            color: #333333;
            display: flex;
            justify-content: space-between;
          "
        >
          <div
            style="
              border-left: 3px solid #6293ff;
              padding-left: 8px;
              display: flex;
              align-items: center;
            "
          >
            相关公告
          </div>
        </div>
      </div>
      <div style="height: 100%">
        <div class="messageItem">
          <div v-for="(item, index) in messageList" :key="index">
            <div style="display: flex; justify-content: space-between">
              <div style="display: flex; align-items: center">
                <span
                  style="font-size: 16px; color: #333333; text-align: left"
                  >{{ item.text }}</span
                >
              </div>
              <span style="color: #999999; font-size: 14px">{{
                item.time
              }}</span>
            </div>
            <span style="color: #999999; font-size: 14px">{{
              item.depart
            }}</span>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
    },
  },
  data() {
    return {
      messageList: [
        {
          text: "科研成果核算系统-评奖申报-自科",
          time: "2025-06-25",
          depart: "后勤服务集团发布",
        },
      ],
    };
  },
  created() {
    console.log("22", this.info);
  },
};
</script>
<style lang="scss" scoped>
/* 关键：覆盖内联 nowrap 样式 + 强制换行 */
/* 保留 scoped，用 ::v-deep 穿透到 v-html 内部元素 */
.article-content {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding: 20px;
  overflow-x: hidden;
}

/* 关键：::v-deep 确保样式作用于 v-html 生成的 span */
.article-content ::v-deep span {
  white-space: normal !important; /* 强制换行，覆盖内联 nowrap */
  text-wrap-mode: wrap !important;
  word-break: break-word !important;
  line-height: 1.8;
  font-size: 16px;
  display: inline-block;
  width: 100% !important;
}

/* 处理段落 */
.article-content ::v-deep p {
  margin: 12px 0;
  max-width: 100%;
  overflow-x: hidden;
}

/* 处理空行 */
.article-content ::v-deep p:empty {
  height: 16px;
}
.content {
  // display: grid;
  // grid-template-columns: 2fr 1fr;
  // gap: 25px;
  width: 100%;
  // padding: 50px 10% 0 10%;
  .left {
    // height: 1000px;
    border-radius: 8px;
    background: linear-gradient(
      to bottom,
      #dce7ee 0%,
      /* 顶部淡黄色 */ #ffffff 10%,
      /* 20% 位置仍是黄色 */ #ffffff 80%,
      /* 80% 位置完全过渡到白色 */ #ffffff 100% /* 底部白色 */
    );
    padding: 20px;
    width: 100%;
    word-break: break-word;
    white-space: normal;
  }
  .right {
    height: 678px;
    background: linear-gradient(
      to bottom,
      #f4ebf1 0%,
      /* 顶部淡黄色 */ #ffffff 15%,
      /* 20% 位置仍是黄色 */ #ffffff 80%,
      /* 80% 位置完全过渡到白色 */ #ffffff 100% /* 底部白色 */
    );
    border-radius: 8px 8px 8px 8px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    .messageItem {
      display: flex;
      flex-direction: column;
      margin-top: 15px;
      background: #f5f7fb;
      padding: 15px;
      border-radius: 4px;
    }
  }
}
</style>
